// Generated by ReScript, PLEASE EDIT WITH CARE


function fontFamilyFromFontName(fontName) {
  if (fontName === "LibreFranklin") {
    return "Libre Franklin";
  } else {
    return "Archivo";
  }
}

export {
  fontFamilyFromFontName,
}
/* No side effect */
